export default __webpack_public_path__ + "icon2b57a55.svg";